import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TemporaryComponent } from './temporary/temporary.component';
import { AuthenticationGuard } from './system/guards/authentication.guard';

const routes: Routes = [
	{ path: '', redirectTo: 'home', pathMatch: 'full' },
	{
		path: 'temp',
		component: TemporaryComponent,
		canActivate: []
	},
	{
		path: 'home',
		loadChildren: () => import('./modules/home/home.module').then((m) => m.HomeModule),
		canActivate: [AuthenticationGuard],
		data: {
			moduleName: 'Home'
		}
	},
	{
		path: 'auth',
		loadChildren: () => import('./modules/auth/auth.module').then((m) => m.AuthModule),
		canActivateChild: [AuthenticationGuard],
		data: {
			moduleName: 'Auth'
		}
	},
	{
		path: 'knowledge-card',
		loadChildren: () => import('./modules/knowledge-card/knowledge-card.module').then((m) => m.KnowledgeCardModule),
		canActivate: [AuthenticationGuard],
		data: {
			moduleName: 'KnowledgeCard'
		}
	},
	{
		path: 'assignment',
		loadChildren: () => import('./modules/assignment/assignment.module').then((m) => m.AssignmentModule),
		canActivate: [AuthenticationGuard],
		data: {
			moduleName: 'Assignment'
		}
	},
	{
		path: 'playlist',
		loadChildren: () => import('./modules/playlist/playlist.module').then((m) => m.PlaylistModule),
		canActivate: [AuthenticationGuard],
		data: {
			moduleName: 'Playlist',
			functionID: ["PL001", "PL002", "PL003", "RES005"]
		}
	},
	{
		path: 'workgroup',
		loadChildren: () => import('./modules/workgroup/workgroup.module').then((m) => m.WorkgroupModule),
		canActivate: [AuthenticationGuard],
		data: {
			moduleName: 'Workgroup'
		}
	},
	{
		path: 'learning-content',
		loadChildren: () => import('./modules/resource/resource.module').then((m) => m.ResourceModule),
		canActivate: [AuthenticationGuard],
		data: {
			moduleName: 'Resource'
		}
	},
	{
		path: 'people',
		loadChildren: () => import('./modules/people/people.module').then((m) => m.PeopleModule),
		canActivate: [AuthenticationGuard],
		data: {
			moduleName: 'People'
		}
	},
	{
		path: 'skills-competency',
		loadChildren: () => import('./modules/skills-competency/skills-competency.module').then((m) => m.SkillsCompetencyModule),
		canActivate: [AuthenticationGuard],
		data: {
			moduleName: 'SkillsCompetency',
			functionID: ['RES007']
		}
	},
	{
		path: 'conversation',
		loadChildren: () => import('./modules/conversation/conversation.module').then((m) => m.ConversationModule),
		canActivate: [AuthenticationGuard],
		data: {
			moduleName: 'Conversation'
		}
	},
	{
		path: 'analytics',
		loadChildren: () => import('./modules/analytics/analytics.module').then((m) => m.AnalyticsModule),
		canActivate: [AuthenticationGuard],
		data: {
			moduleName: 'Analytics',
			functionID: ['VA001']
		}
	},
	{
		path: 'questions',
		loadChildren: () => import('./modules/questions/questions.module').then((m) => m.QuestionsModule),
		canActivate: [AuthenticationGuard],
		data: {
			moduleName: 'Questions',
			functionID: ["QS001", "QS002", "QS003"]
		}
	},
	{
		path: 'assessment-questions',
		loadChildren: () => import('./modules/assessment-questions/assessment-questions.module').then((m) => m.AssessmentQuestionsModule),
		canActivate: [AuthenticationGuard],
		data: {
			moduleName: 'AssessmentQuestions',
			functionID: ["RES002", "COU004"]
		}
	},
	{
		path: 'scorm',
		loadChildren: () => import('./modules/scorm/scorm.module').then((m) => m.ScormModule),
		canActivate: [AuthenticationGuard],
		data: {
			moduleName: 'Scorm',
			functionID: ["RES002", "COU004"]
		}
	},
	{
		path: 'functional-roles',
		loadChildren: () => import('./modules/functional-roles/functional-roles.module').then((m) => m.FunctionalRolesModule),
		canActivate: [AuthenticationGuard],
		data: {
			moduleName: 'FunctionalRoles',
			functionID: ['RES006']
		}
	},
	{
		path: 'setup',
		loadChildren: () => import('./modules/setup/setup.module').then((m) => m.SetupModule),
		canActivate: [AuthenticationGuard],
		data: {
			moduleName: 'Setup'
		}
	},
	{
		path: 'course',
		loadChildren: () => import('./modules/course/course.module').then((m) => m.CourseModule),
		canActivate: [AuthenticationGuard],
		data: {
			moduleName: 'Course',
			functionID: ["RES002", "RES005"]
		}
	},
	{
		path: 'knowledge-bead',
		loadChildren: () => import('./modules/knowledge-bead/knowledge-bead.module').then((m) => m.KnowledgeBeadModule),
		canActivate: [AuthenticationGuard],
		data: {
			moduleName: 'KnowledgeBead',
			functionID: ["KB001", "KB002", "KB003", "RES005"]
		}
	},
	{
		path: 'forwards',
		loadChildren: () => import('./modules/forwards/forwards.module').then((m) => m.ForwardsModule),
		canActivate: [AuthenticationGuard],
		data: {
			moduleName: 'ForwardsModule'
		}
	},
	{
		path: 'master-list',
		loadChildren: () => import('./modules/master-list/master-list.module').then((m) => m.MasterListModule),
		canActivate: [AuthenticationGuard],
		data: {
			moduleName: 'MasterList',
			functionID: ['RES003']
		}
	},
	{
		path: 'assessment',
		loadChildren: () => import('./modules/assessment/assessment.module').then((m) => m.AssessmentModule),
		canActivate: [AuthenticationGuard],
		data: {
			moduleName: 'Assessment'
		}
	},
	{
		path: 'leaderboard',
		loadChildren: () => import('./modules/leaderboard/leaderboard.module').then((m) => m.LeaderboardModule),
		canActivate: [AuthenticationGuard],
		data: {
			moduleName: 'LeaderBoard'
		}
	},
	{
		path: 'mooc',
		loadChildren: () => import('./modules/mooc/mooc.module').then((m) => m.MoocModule),
		canActivate: [AuthenticationGuard],
		data: {
			moduleName: 'MOOC',
			functionID: ["MOOC001", "MOOC002", "MOOC003", "RES005"]
		}
	},
	{
		path: 'internal-event',
		loadChildren: () => import('./modules/internal-event/internal-event.module').then((m) => m.InternalEventModule),
		canActivate: [AuthenticationGuard],
		data: {
			moduleName: 'InternalEvent',
			functionID: ["IEV001", "IEV002", "IEV003", "RES005"]
		}
	},
	{
		path: 'external-event',
		loadChildren: () => import('./modules/external-event/external-event.module').then((m) => m.ExternalEventModule),
		canActivate: [AuthenticationGuard],
		data: {
			moduleName: 'ExternalEvent',
			functionID: ["EEV001", "EEV002", "EEV003", "RES005"]
		}
	},
	{
		path: 'channels',
		loadChildren: () => import('./modules/channels/channels.module').then((m) => m.ChannelsModule),
		canActivate: [AuthenticationGuard],
		data: {
			moduleName: 'Channels',
			functionID: ['MC001']
		}
	},
	{
		path: 'promotion',
		loadChildren: () => import('./modules/promotion/promotion.module').then((m) => m.PromotionModule),
		canActivate: [AuthenticationGuard],
		data: {
			moduleName: 'Promotion'
		}
	}
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule]
})
export class AppRoutingModule { }
